export const sharedI18nKey = suffix => `RichTextLib.shared.${suffix}`;
export const LazyLoadingTypes = {
  default: null,
  lazy: 'lazy',
  eager: 'eager'
};
export const CustomizeLazyLoadingAttributesUrl = 'https://knowledge.hubspot.com/cos-pages-editor/how-do-i-insert-an-image-in-a-page-or-blog-post#edit-advanced-image-options';
export const CustomizeLinkAttributesUrl = 'https://knowledge.hubspot.com/cos-pages-editor/how-do-i-insert-a-link-on-a-hubspot-page#customize-your-link-s-attributes-optional';